// Pure display rules for claims: status tone, tracker labels, which buttons a
// role is offered, and the sentences shown after a submit. The API enforces
// every action (404 for a claim that is not yours, 409 for a bad move); these
// only decide what to show.
const TONES = {
  draft: 'neutral', ready: 'neutral', submitted: 'neutral', rejected: 'bad', accepted: 'neutral', pending: 'warn',
  paid: 'good', partially_paid: 'warn', denied: 'bad', corrected: 'neutral', voided: 'neutral',
};
export const statusTone = (s) => TONES[s] || 'neutral';
export const TRACKER_STEPS = ['Created', 'Submitted', 'Accepted', 'Adjudicated', 'Paid'];

const NONE = { attest: false, ready: false, unready: false, edit: false, submit: false, void: false, reopen: false, sync: false, note: true };

export function actionsFor(role, claim, validationOk) {
  const admin = role === 'admin';
  const a = { ...NONE };
  switch (claim.status) {
    case 'draft':
      a.attest = !claim.note_attested_at;
      a.edit = true;
      a.ready = Boolean(validationOk) && Boolean(claim.note_attested_at);
      a.void = admin;
      break;
    case 'ready':
      a.unready = true;
      a.submit = admin;
      a.void = admin;
      a.attest = !claim.note_attested_at;
      break;
    case 'rejected':
      a.reopen = admin;
      a.sync = true;
      break;
    case 'submitted': case 'accepted': case 'pending': case 'partially_paid': case 'paid': case 'denied':
      a.sync = true;
      break;
    default:
      break;   // corrected, voided: timeline notes only
  }
  return a;
}

export function submitOutcomeText(r) {
  const head = `Claim #${r.claimId}: `;
  const why = (r.errors || []).join(' | ');
  switch (r.outcome) {
    case 'submitted': return `${head}Sent to Stedi${r.correlationId ? ` (correlation ${r.correlationId})` : ''}.`;
    case 'skipped': return `${head}Skipped: ${why || 'not ready'}.`;
    case 'edit_rejected': return `${head}Rejected by Stedi's edits: ${why}`;
    default: return `${head}Not sent: ${why || 'unexpected error'}`;
  }
}

export function queueOf(c) {
  if (c.attention && c.attention.flag) return 'attention';
  if (c.status === 'draft') return 'draft';
  if (c.status === 'ready') return 'ready';
  if (['submitted', 'accepted', 'pending', 'partially_paid'].includes(c.status)) return 'awaiting';
  return 'done';
}

export const describeProblems = (p) => (p && p.length ? p.join('; ') : 'Ready to create');
